var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlayButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 150 151",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#playButton_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -0.001,
  y: 0.333,
  width: 150,
  height: 150,
  rx: 30.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.749 150.333h-87.5a31.284 31.284 0 0 1-31.25-31.25v-87.5A31.287 31.287 0 0 1 31.249.334h87.5a31.287 31.287 0 0 1 31.25 31.25v87.5a31.288 31.288 0 0 1-31.25 31.25Zm-87.5-137.5a18.75 18.75 0 0 0-18.75 18.75v87.5a18.753 18.753 0 0 0 18.75 18.75h87.5a18.75 18.75 0 0 0 18.75-18.75v-87.5a18.748 18.748 0 0 0-18.75-18.75h-87.5Zm27.137 93.782a14.8 14.8 0 0 1-7.412-2.019 14.453 14.453 0 0 1-7.275-12.631V58.702a14.606 14.606 0 0 1 21.875-12.681L98.561 62.49a14.596 14.596 0 0 1 7.664 12.672 14.599 14.599 0 0 1-7.357 12.853l-33.6 16.793a13.744 13.744 0 0 1-6.882 1.807Zm-.156-50c-.344 0-.683.09-.981.262a2.044 2.044 0 0 0-1.05 1.825v33.263a2.107 2.107 0 0 0 3.125 1.831l33.6-16.8a1.963 1.963 0 0 0 .75-1.662 2.031 2.031 0 0 0-1.056-1.826L59.655 57.04a2.889 2.889 0 0 0-1.425-.425Z",
  fill: "#FF3368"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "playButton_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  x: -0.001,
  y: 0.333,
  width: 150,
  height: 150,
  rx: 30.5,
  fill: "#fff"
})))));
export default SvgPlayButton;